'use strict';

var $                       = require('jquery');
var Core                    = require('../core/core.js');
var InspectorLabel          = require('./inspector__label.js');
var InspectorValueUnitFixed = require('./inspector__valueunitfixed.js');
var InspectorImage          = require('./inspector__image.js');

class InspectorRow extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'notFlexContainer': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class="editor__inspector__item editor__inspector__item--multiple <% if(!notFlexContainer) { %> flex__container <% } %> js-editor__inspector__item--multiple"></div>
        `;

        super.render();
    }

    /**
     * Clears the inspector row
     */
    clear(){
        this.$el.html('');
    }

    //TODO: reuse this from inspector group?
    addLabel(label, tooltip){
        return new InspectorLabel({
            target: this.$el,
            fields: {
                'title': label,
                'tooltip': tooltip
            }
        });
    }

    addValueUnitFixed(title, value, units, tooltip){
        return new InspectorValueUnitFixed({
            target: this.$el,
            fields: {
                'title': title,
                'value': value,
                'unit': units,
                'tooltip': tooltip
            }
        });
    }

    addImage(title, value, tooltip){
        return new InspectorImage({
            target: this.$el,
            fields: {
                'title': title,
                'value': value,
                'tooltip': tooltip
            }
        });
    }
}

module.exports = InspectorRow;